import 'hammerjs';

import { LOCALE_ID } from '@angular/core';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxErrorsModule } from '@ultimate/ngxerrors';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { DragulaModule } from 'ng2-dragula/ng2-dragula';
import { DataListModule, DataTableModule, SharedModule } from 'primeng/primeng';

import { environment } from '../environments/environment';
import { AppMaterialModule } from './app-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AddApplicationComponent } from './components/add-application/add-application.component';
import { AddMeetupComponent } from './components/add-meetup/add-meetup.component';
import { AddMemberComponent } from './components/add-member/add-member.component';
import { AddPaymentComponent } from './components/add-payment/add-payment.component';
import { AddSponsorshipComponent } from './components/add-sponsorship/add-sponsorship.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { AssignMembersComponent } from './components/assign-members/assign-members.component';
import { AttendeesComponent } from './components/attendees/attendees.component';
import { CancelApplicationComponent } from './components/cancel-application/cancel-application.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CheckInApplicationComponent } from './components/check-in-application/check-in-application.component';
import { ConfirmApplicationComponent } from './components/confirm-application/confirm-application.component';
import { CoverComponent } from './components/cover/cover.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ForwardApplicationComponent } from './components/forward-application/forward-application.component';
import { LoginComponent } from './components/login/login.component';
import { MeetupsComponent } from './components/meetups/meetups.component';
import { MembersComponent } from './components/members/members.component';
import { MoneyPerApplicationComponent } from './components/money-per-application/money-per-application.component';
import { MoneyPerMeetupComponent } from './components/money-per-meetup/money-per-meetup.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { RemovePaymentComponent } from './components/remove-payment/remove-payment.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ReviewApplicationComponent } from './components/review-application/review-application.component';
import { RootComponent } from './components/root/root.component';
import { UpdateApplicationComponent } from './components/update-application/update-application.component';
import { UpdateMeetupComponent } from './components/update-meetup/update-meetup.component';
import { UpdateMemberComponent } from './components/update-member/update-member.component';
import { UpdateUserComponent } from './components/update-user/update-user.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UsersComponent } from './components/users/users.component';
import { WeGotYourApplicationComponent } from './components/we-got-your-application/we-got-your-application.component';
import { AuthGuard } from './guards/auth.guard';
import { ApplicationService } from './services/application.service';
import { AttendeeService } from './services/attendee.service';
import { AuthService } from './services/auth.service';
import { MeetupService } from './services/meetup.service';
import { MemberService } from './services/member.service';
import { ReportService } from './services/report.service';
import { UserService } from './services/user.service';

@NgModule({
	declarations: [
		RootComponent,
		CoverComponent,
		AddApplicationComponent,
		NavigationComponent,
		DashboardComponent,
		MeetupsComponent,
		LoginComponent,
		AttendeesComponent,
		UsersComponent,
		AddMeetupComponent,
		ApplicationsComponent,
		UpdateMeetupComponent,
		UpdateUserComponent,
		UserProfileComponent,
		ResetPasswordComponent,
		ChangePasswordComponent,
		ConfirmApplicationComponent,
		WeGotYourApplicationComponent,
		CancelApplicationComponent,
		ReviewApplicationComponent,
		AddUserComponent,
		AddSponsorshipComponent,
		AddPaymentComponent,
		CheckInApplicationComponent,
		ForwardApplicationComponent,
		MembersComponent,
		AddMemberComponent,
		UpdateMemberComponent,
		AssignMembersComponent,
		MoneyPerApplicationComponent,
		MoneyPerMeetupComponent,
		UpdateApplicationComponent,
		RemovePaymentComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		NgxErrorsModule,

		// AngularFire
		AngularFireModule.initializeApp(environment.firebase),
		AngularFireDatabaseModule,
		AngularFireAuthModule,

		// PrimeNG
		DataTableModule,
		DataListModule,
		SharedModule,

		// Dragula
		DragulaModule,

		// Routing
		AppRoutingModule,

		// App Material
		AppMaterialModule
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'es-MX' },
		AuthService,
		UserService,
		MeetupService,
		ApplicationService,
		AttendeeService,
		MemberService,
		ReportService,

		AuthGuard
	],
	entryComponents: [
		UserProfileComponent,
		UpdateUserComponent,
		AddMeetupComponent,
		UpdateMeetupComponent,
		ConfirmApplicationComponent,
		CancelApplicationComponent,
		AddUserComponent,
		AddSponsorshipComponent,
		AddPaymentComponent,
		CheckInApplicationComponent,
		ForwardApplicationComponent,
		AddMemberComponent,
		UpdateMemberComponent,
		AssignMembersComponent,
		RemovePaymentComponent
	],
	bootstrap: [RootComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/app.module.ts